





















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { DataListItem, DataViewItem } from '@/types';
import EventBus from '@/utils/EventBus';
import { routeNames } from '@/utils/router';
import { State, Getter } from 'vuex-class';
import { RootState } from '@/store';
import { navigationQueryName } from '@/utils';
import { findInDataByRegisterId } from '@/utils/statementObjectData';
import { DataManagementState } from '@/store/modules/dataManagement';

@Component({name: 'app-data-list'})
export default class extends Vue {
  @Prop({type: Array, required: true})
  private list!: DataListItem[];

  @State((state: RootState) => state.dataManagement.content)
  private allDataContent!: DataListItem[] & DataManagementState['content'];

  @State((state: RootState) => state.dataManagement.iframeUrlQuery)
  private iframeUrlQuery!: string;

  @State((state: RootState) => state.dataManagement.navigatedListIndexes)
  private navigatedListIndexes!: string[];

  @Getter('dataManagement/listTitles')
  private listTitlesSettings!: string[];

  private currentListToRender: DataListItem[] & DataViewItem[] = [];

  public created(): void {
    this.setListIndexesFromRouteQuery();
    this.renderDataDependsOnNavigation();
    this.initNavigationEventBusListener();
  }

  @Watch('list')
  private onListLoaded(): void {
    this.setListIndexesFromRouteQuery();
    this.renderDataDependsOnNavigation();
  }

  @Watch('iframeUrlQuery')
  private onRegisterIdReceivedFromParentWindow(): void {
    const registerId: number = Number((this.iframeUrlQuery.split(navigationQueryName)[1] || '').replace('=', ''));
    if (registerId) {
      this.renderSubregisterView(registerId);
    }
  }

  private get currentListTitle(): string {
    return this.listTitlesSettings[this.navigatedListIndexes.length + 1] || '';
  }

  private renderSubregisterView(registerId: DataListItem['id']): void {
    const dataViewItem: DataListItem | undefined = findInDataByRegisterId(registerId || 0, this.allDataContent) as DataListItem | undefined;
    if (dataViewItem && dataViewItem.children) {
      this.renderDataViewItem(dataViewItem.children![0], 0);
    }
  }

  private renderDataDependsOnNavigation(): void {
    const navigatedDataList: DataListItem[] & DataViewItem[] = this.getDataListByNavigatedListIndexes();
    if (navigatedDataList) {
      const lastNavigatedIndex = this.navigatedListIndexes[this.navigatedListIndexes.length - 1];
      if (this.navigatedListIndexes.length) {
        this.checkAndRenderChildData(navigatedDataList, lastNavigatedIndex);
      } else {
        this.setListToRender(navigatedDataList, lastNavigatedIndex);
      }
    }
  }

  private getDataListByNavigatedListIndexes(): DataListItem[] & DataViewItem[] {
    let currentList = this.list as DataListItem[] & DataViewItem[];
    this.navigatedListIndexes.forEach((index: string) => {
      currentList = ((currentList || [])[index.split('-')[1]] || {}).children as DataListItem[] & DataViewItem[];
    });
    return currentList;
  }

  private renderPreviouseList(): void {
    this.$store.commit('dataManagement/REMOVE_LAST_NAVIGATED_LIST_INDEX');
    const backList: DataListItem[] & DataViewItem[] = this.getDataListByNavigatedListIndexes();
    this.setListToRender(backList);
  }

  private checkAndRenderChildData(childList: DataListItem[] & DataViewItem[], index?): void {
    if (!childList.length) {
      this.renderDataViewItem({} as DataViewItem, index);
    } else if ((childList[0] && childList[0].children !== undefined)) { // if `DataListItem`
      this.setListToRender(childList, index);
    } else if ((childList[0] && childList[0].sections !== undefined)) { // if `DataViewItem`
      this.renderDataViewItem(childList[0] || {}, index);
    }
  }

  private renderDataViewItem(dataList: DataViewItem, index: number): void {
    this.$store.commit('dataManagement/SET_CURRENT_DATA_VIEW_ITEM', dataList || {});
    if (index !== undefined) {
      this.$store.commit('dataManagement/ADD_NAVIGATED_LIST_INDEX', index);
    }
    this.$router.push({
      name: routeNames.dataItem,
      query: {
        ...this.$route.query,
      }
    });
  }

  private setListToRender(list: DataListItem[] & DataViewItem[], index?: string): void {
    if (list) {
      this.currentListToRender = list;
    } else {
      this.renderPreviouseList();
    }
    if (index !== undefined) {
      this.$store.commit('dataManagement/ADD_NAVIGATED_LIST_INDEX', index);
    }
  }

  private initNavigationEventBusListener(): void {
    EventBus.$off('nav:go-previous-data-list');
    EventBus.$on('nav:go-previous-data-list', () => {
      this.renderPreviouseList();
    });
  }

  private setListIndexesFromRouteQuery(): void {
    if (this.$route.query[navigationQueryName]) {
      (this.$route.query[navigationQueryName] as string).split(',').forEach((index: string) => {
        this.$store.commit('dataManagement/ADD_NAVIGATED_LIST_INDEX', index);
      });
    }
  }

  private setRegisterId(registerId: DataListItem['id'] & number): void {
    registerId && this.$store.commit('dataManagement/SET_REGISTER_ID', registerId);
  }

}
